import type { EntityState } from '@reduxjs/toolkit';

export const TAB_TYPES = ['tiles', 'bulkTrade', 'bulkOrder'] as const;

export interface TabsState {
  activeTabId: string;
  // defaultClientId : redundant with UserContext
  // but we sometime need it outside UserContext
  defaultClientId: number;
  tabs: EntityState<Tab, Tab['id']>;
}
export type TabType = (typeof TAB_TYPES)[number];

interface BaseTilesType {
  id: string;
  tabName: string;
  clientId: number;
  /**
   * zoomedTileId is pointing to a tile currently in "zoomed" state (option, accumulator).
   * This piece of information must survive the tab switching, but is not to be saved in workspace
   **/
  zoomedTileId?: string;
}

// TODO: it would be cleaner not to have sharedWithUsers and ownerEmail on tabs that are not shared.

interface NotSharedTilesType extends BaseTilesType {
  tabType: 'tiles';
  isShared: false;
  sharedWithUsers?: undefined;
  ownerEmail?: undefined;
}

interface SharedTilesType extends BaseTilesType {
  tabType: 'tiles';
  isShared: true;
  sharedWithUsers: string[];
  ownerEmail: string;
}

type TilesTab = SharedTilesType | NotSharedTilesType;
type BulkTab = {
  id: string;
  tabName: string;
  clientId: number;
  tabType: 'bulkTrade' | 'bulkOrder';
  isShared: false;
  sharedWithUsers?: undefined;
  ownerEmail?: undefined;
};

export type Tab = TilesTab | BulkTab;
